import AgentHubEarnYourOwnTourBanner from 'agentHub/components/AgentHubEarnYourOwnTourBanner'
import {
  markAgentHubEarnYourOwnTourModalDismissed,
} from 'agentHub/storage/agentHubEarnYourOwnTourModalStorage'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import Modal from 'LuxKit/Modal/Modal'
import type { MouseEventHandler } from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  margin: 0 auto;
  padding: 0;

  .flush-vertical-top {
    padding-top: 0;
    padding-bottom: 0;
  }
`

function AgentHubEarnYourOwnTourModal() {
  const modalContext = useModalElementContext()

  const dismissModal = useCallback(() => {
    markAgentHubEarnYourOwnTourModalDismissed()
    modalContext.resolve()
  }, [modalContext])

  const handleClose = useCallback<MouseEventHandler<HTMLElement>>(() => {
    dismissModal()
  }, [dismissModal])

  const handleFindOutMoreClick = useCallback(() => {
    dismissModal()
  }, [dismissModal])

  return (
    <StyledModal
      flush
      flushVerticalTop
      flushListItems
      isHeaderOverlay
      isSecondaryActionHidden
      isPrimaryActionHidden
      size="L"
      title=""
      onClose={handleClose}
    >
      <AgentHubEarnYourOwnTourBanner
        shouldShowCloseButton
        variant="modal"
        onCloseClick={dismissModal}
        onFindOutMoreClick={handleFindOutMoreClick}
      />
    </StyledModal>
  )
}

export default AgentHubEarnYourOwnTourModal
